import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { authFetch } from "../../lib/api"

const STATUS_CLASS = {
  submitted: "dashboard-badge--submitted",
  in_review: "dashboard-badge--in_review",
  approved: "dashboard-badge--approved",
  rejected: "dashboard-badge--rejected",
}

export default function RentalApplications() {
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  useEffect(() => {
    setError("")
    authFetch("/api/rental-applications")
      .then((r) => r.json())
      .then((data) => {
        if (data.error) setError(data.error)
        else setList(data.rentalApplications || [])
      })
      .catch(() => setError("Failed to load rental applications"))
      .finally(() => setLoading(false))
  }, [])

  return (
    <section className='dashboard-card'>
      <div className='dashboard-card__header'>
        <div>
          <span className='dashboard-eyebrow'>Rental progress</span>
          <h2>Applications</h2>
          <p>Applications you have submitted. Status updates will appear here.</p>
        </div>
        <Link to='/listings' className='dashboard-primary-action'>
          <i className='fa-solid fa-file-circle-plus'></i>
          Apply for a home
        </Link>
      </div>

      {error && <p className='dashboard-error'>{error}</p>}
      {loading ? (
        <p>Loading...</p>
      ) : list.length === 0 ? (
        <div className='dashboard-empty'>No applications yet.</div>
      ) : (
        <ul className='dashboard-list'>
          {list.map((item) => (
            <li key={item.id} className='dashboard-list__row'>
              <div>
                {item.listing ? (
                  <Link to={`/listings/${item.listingId}`}>{item.listing.name}</Link>
                ) : (
                  <strong>Listing {item.listingId}</strong>
                )}
                <div className='dashboard-list__meta'>
                  <span className={`dashboard-badge ${STATUS_CLASS[item.status] || ""}`}>
                    {item.status.replace("_", " ")}
                  </span>
                </div>
              </div>
              <div className='dashboard-list__actions'>
                <Link to={`/listings/${item.listingId}`} className='btn btn--secondary'>
                  View listing
                </Link>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
